import { render, staticRenderFns } from "./location-allowances.vue?vue&type=template&id=488dfe02&"
import script from "./location-allowances.vue?vue&type=script&lang=js&"
export * from "./location-allowances.vue?vue&type=script&lang=js&"
import style0 from "./location-allowances.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports